export default {
    data() {
        return {
            key: '',
            type: '',
            dot: '',
            operand: '',
            amount: '',
            cost: '',
            supplier: ''
        };
    }
}